module.exports = __webpack_public_path__ + "assets/gift.05194a98.svg";